import { render, staticRenderFns } from "./YourSynchronicityExtension.vue?vue&type=template&id=6a7470a8&scoped=true&"
import script from "./YourSynchronicityExtension.vue?vue&type=script&lang=js&"
export * from "./YourSynchronicityExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7470a8",
  null
  
)

export default component.exports